import { useDispatch, useSelector } from 'react-redux';
import { setLanguageCode, updateLanguageCode } from 'lib/actions/languages';
import { fetchPricePlans } from 'lib/actions/pricePlans';
import { getLanguage } from 'lib/selectors';
import useLocalStorage from 'utils/hooks/useLocalStorage';
import { useEffect } from 'react';

export default function useUpdateLanguage() {
    const dispatch = useDispatch();
    const language = useSelector(getLanguage);
    const [storedValue, setLangInStorage] = useLocalStorage(
        'languageCode',
        null,
    );

    useEffect(() => {
        dispatch(updateLanguageCode(storedValue || 'eng'));
    }, [dispatch, storedValue]);

    const handleChange = async (_, value) => {
        setLangInStorage(value);
        await dispatch(updateLanguageCode(value));
        dispatch(setLanguageCode(value));
        dispatch(fetchPricePlans(value));
    };

    return [language, handleChange];
}
